import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type SlideFlagStatus = "none" | "requires-attention" | "resolved";

const mapStatusToColor: { [key in SlideFlagStatus]: string } = {
  none: "black",
  "requires-attention": "var(--imperialRed)",
  resolved: "gray",
};

interface SlideFlagIconProps {
  status?: SlideFlagStatus;
}
export const SlideFlagIcon: React.FC<SlideFlagIconProps> = ({
  status = "requires-attention",
  ...rest
}) => (
  <FontAwesomeIcon
    icon={"flag"}
    className={"slideFlagIcon"}
    color={mapStatusToColor[status]}
    {...rest}
  />
);
